"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-vittore-del-lazio": {
    "469fd916": [{
      "hkey": "97213f42",
      "slug": "rocca-d-evandro-scalo-san-cesario",
      "name": "Rocca d'Evandro Scalo-San Cesario",
      "primary": true,
      "skipSearch": false
    }],
    "rocca-d-evandro-scalo": [{
      "hkey": "97213f42",
      "slug": "rocca-d-evandro-scalo-san-cesario",
      "name": "Rocca d'Evandro Scalo-San Cesario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;